import React from 'react';
import { Image } from 'react-bootstrap';
import logo from '../../../assets/images/navimag-logo.png';

const MainLogo = ({ src = logo, ...props }) => (
  <Image src={src} alt="Logo" className="d-inline-block align-top" {...props} />
);

export default MainLogo;
